export default {
      id: "completed-challenge-usage",
      viewBox: "0 0 64 67",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#completed-challenge",
      toString: function () {
        return this.url;
      }
    }